export const MEDCOMMS_ASSEMBLER_HELP = 'https://collaboration.merck.com/sites/VIORG/SitePages/Modular-Content.aspx';
